import React, { useRef, useEffect } from 'react';
import { ChatMessage } from '@my-game/shared-types';
import { useGame } from '../../contexts/GameContext';
import './MessageList.css';

interface MessageListProps {
  messages: ChatMessage[];
}

const MessageList: React.FC<MessageListProps> = ({ messages }) => {
  const { state: gameState } = useGame();
  const messagesEndRef = useRef<HTMLDivElement>(null);

  // Автоскролл к последнему сообщению
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const formatTime = (timestamp: string) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('ru-RU', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const isOwnMessage = (message: ChatMessage) => {
    return message.characterId === gameState.character?.id;
  };

  return (
    <div className="message-list">
      {messages.length === 0 ? (
        <div className="message-list-empty">
          Нет сообщений. Начните общение!
        </div>
      ) : (
        messages.map((message) => (
          <div 
            key={message.id} 
            className={`message-line ${isOwnMessage(message) ? 'message-own' : ''}`}
          >
            <span className="message-time">[{formatTime(message.timestamp)}]</span>
            {' '}
            <span className="message-author">{message.characterNickname}</span>
            {' '}
            <span className="message-level">[{message.characterLevel}]</span>
            {' > '}
            <span className="message-text">{message.text}</span>
          </div>
        ))
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
